module.exports = __webpack_public_path__ + "img/BT.07f0b31c.svg";